import * as types from './mutation-types';
import { defaultState } from './state';

const resetState_ = state => {
	Object.assign(state, defaultState);
};
export default {
	resetState_,
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},

	[types.SET_UNMANAGED_TABLE_LIST]: (state, { key, list }) => {
		state[key] = list.map(item => {
			return { label: item.text, value: item.value };
		});
	},

	[types.SET_SCHEMA_LIST]: (state, { key, list }) => {
		let list_new = [{ label: 'All', value: '' }];
		list.map(item => {
			list_new.push({ label: item.SCHEMA, value: item.SCHEMA });
		});
		state[key] = list_new;
	},

	[types.SET_OPTION_PLANT_LIST]: (state, { key, list }) => {
		state[key] = list.map(item => {
			return { label: item.commCdName, value: item.commCd };
		});
	},

	[types.SET_OPTION_LIST]: (state, { key, list }) => {
		let list_new = [{ label: 'All', value: '' }];
		list.map(item => {
			list_new.push({ label: item.commCdName, value: item.commCd });
		});
		state[key] = list_new;
	},

	[types.SET_OPTION_FORM_LIST]: (state, { key, list }) => {
		let list_new = [{ label: 'All', value: '' }];
		list.map(item => {
			list_new.push({ label: item.text, value: item.value });
		});
		state[key] = list_new;
	},

	[types.SET_OPTION_CODE_LIST]: (state, { key, list }) => {
		let list_new = [{ label: 'All', value: '' }];
		list.map(item => {
			list_new.push({ label: item.codeName, value: item.code });
		});
		state[key] = list_new;
	},

	[types.SET_SEARCH_PARAM]: (state, params) => {
		state.searchParams = { ...state.searchParams, ...params };
	},

	[types.SET_TABLE_MANAGEMENT_MODAL_VALUE]: (state, { key, value }) => {
		state.tableDataManagementModalValue[key] = value;
	}
};
